import { render, staticRenderFns } from "./CoozzyFullScreenIcon.vue?vue&type=template&id=4b7f06ef&scoped=true"
import script from "./CoozzyFullScreenIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFullScreenIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFullScreenIcon.vue?vue&type=style&index=0&id=4b7f06ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f06ef",
  null
  
)

export default component.exports